// extracted by mini-css-extract-plugin
export default {"container":"ServiceTime_container__nwyJW","content":"ServiceTime_content__h7DCl","emphasis":"ServiceTime_emphasis__tHlPW"};